import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'react-bootstrap';
import { MdOutlineResetTv } from 'react-icons/md';
import { postingStatusData, postingTypeData } from '../../utils/defaultConstants';

const AppPostingsFilterDrawer = ({
	filterDrawerVisible,
	setFilterDrawerVisible,
	postingType,
	setPostingType,
	postingStatus,
	setPostingStatus,
	loading,
	handleResetFilter,
	handleSearch,
}) => {
	return (
		<Sidebar
			visible={filterDrawerVisible}
			position="right"
			onHide={() => setFilterDrawerVisible(false)}
			style={{ width: '28rem', maxWidth: '90vw' }}
			header="Filters"
		>
			<div className="d-flex flex-column justify-content-between h-100 gap-1">
				<div>
					<div className="field">
						<label htmlFor="postingType">Posting Type</label>
						<Dropdown
							inputId="postingType"
							value={postingType}
							onChange={(e) => setPostingType(e.value)}
							options={postingTypeData}
							optionLabel="name"
							placeholder="Posting Type"
							className="w-100 md:h-3rem p-inputtext-sm"
						/>
					</div>

					<div className="field">
						<label htmlFor="postingStatus">Posting Status</label>
						<Dropdown
							inputId="postingStatus"
							value={postingStatus}
							onChange={(e) => setPostingStatus(e.value)}
							options={postingStatusData}
							optionLabel="name"
							placeholder="Posting Status"
							className="w-100 md:h-3rem p-inputtext-sm"
						/>
					</div>
				</div>

				<div className="d-flex gap-2 justify-content-between mt-2 pt-3 border-top prime-react-btn">
					<Button
						variant="outline-secondary"
						disabled={loading}
						onClick={handleResetFilter}
						className="w-100"
					>
						Reset
					</Button>
					<button
						disabled={loading}
						onClick={handleSearch}
						className="w-100 btn submit-btn text-white"
					>
						Search
					</button>
				</div>
			</div>
		</Sidebar>
	);
};

export default AppPostingsFilterDrawer;

